import type { PortfolioUpdate } from './useUpdates';

import { Brief } from './Brief';
import { Narrative } from './Narrative';
import { Event } from './Event';
import { Item } from './Item';

type Props = {
  updates: PortfolioUpdate[];
};

export const PopulatedState = ({ updates }: Props) => (
  <div
    role="list"
    className="grid auto-rows-min grid-cols-1 gap-x1_25 md:gap-x0_5"
  >
    {updates.map((n) => {
      const { type, id } = n;
      return type === 'narrative' ? (
        <Narrative key={id} {...n}>
          <Item {...n} />
        </Narrative>
      ) : type === 'brief' ? (
        <Brief key={id} {...n}>
          <Item {...n} />
        </Brief>
      ) : type === 'event' ? (
        <Event key={id} {...n}>
          <Item {...n} />
        </Event>
      ) : null;
    })}
  </div>
);
